import React, { useEffect, useState } from 'react';
import { ReactComponent as BackIcon } from 'assets/img/svg/BackButton.svg';
import { useHistory } from "react-router";
import { getDropdowns } from './constants';
import ParentFeedbackConfig from './ParentFeedbackConfig';

const ParentFeedbackConfigPage = ({ userPermissions }) => {
    const [dropdownData, setDropdownData] = useState({
        loading: false,
        data: {}
    });

    const history = useHistory();

    const getDropdown = async () => {
        setDropdownData(prev => ({ ...prev, loading: true }));
        const data = await getDropdowns();
        setDropdownData({ loading: false, data });
    }

    useEffect(() => {
        getDropdown()
    }, []);


    return (
        <div className={`remove-container-top-space d-flex flex-column p-3`}>

            <div className='mb-3'>
                <BackIcon onClick={() => history.goBack()} />
                <span className="ml-3 heading-4 color-dark">
                    Feedback collection config
                </span>
            </div>

            <ParentFeedbackConfig
                userPermissions={userPermissions}
                dropdownData={dropdownData?.data}
                setDropdownData={setDropdownData}
                dropdownDataLoading={dropdownData?.loading}
            />

            <ParentFeedbackConfig
                userPermissions={userPermissions}
                setDropdownData={setDropdownData}
                dropdownData={dropdownData?.data}
                dropdownDataLoading={dropdownData?.loading}
                isBranchLevelConfig
            />
        </div>
    )
}

export default ParentFeedbackConfigPage;